/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PointVo {
  type: 'Point'
  coordinates: number[]
}

export interface Camera {
  id: number
  geom: PointVo
  name: string
  description: string
  url: string
}

export interface Ship {
  id: string
  type: string
  cnname: string
  enname: string
  name: string
  g: string
  len: number
  wid: number
  a: number
  b: number
  c: number
  d: number
  geom: PointVo
  lon: number
  lat: number
  /** @format date-time */
  time: string
  spd: number
  from: string
  status: string
  cog: string
  /** @format date-time */
  mt: string
  isactive: string
  num: string
  ord: string
  postype: string
  pt: string
  firm: string
  gt: string
}

export interface ShipinfoDto {
  mmsi: string[]
}

export interface ShipinfoVo {
  id: string
  type: string
  cnname: string
  name: string
  g: string
  len: number
  wid: number
  a: number
  b: number
  c: number
  d: number
  lon: number
  lat: number
  time: number
  spd: number
  from: number
  status: number
  cog: number
  mt: number
  ct: number
  build: string
  gt: string
  hdg: number
  dest: string
  eta: string
  callsign: string
  imo: string
}

export interface Navigationmark {
  number: string
  xAxis: number
  yAxis: number
  longitude: number
  latitude: number
  type: string
  name: string
  typename: string
  catcam: string
  colour: string
  colpat: string
  scamin: string
  id: string
  geom: string
}

export interface Dwrtcl1 {
  id: number
  geom: object
  rcid: number
  cattrk: number
  drval1: number
  drval2: number
  nobjnm: string
  orient: number
  trafic: number
}

export interface Dwrtpc {
  id: number
  geom: object
}

export interface Dwrtpt1 {
  id: number
  geom: object
  rcid: number
  drval1: number
  drval2: number
  nobjnm: string
  orient: number
  trafic: number
  scamin: number
  scamax: number
}

export interface Bridgepier {
  smuserid: number
  entityhand: number
  entitytype: string
  layer: string
  layerfroze: number
  layerlocke: number
  layeron: number
  elevation: number
  thickness: number
  colorindex: number
  linestyle: string
  blockname: string
  blockrotat: number
  linewidth: number
  x: number
  y: number
  z: number
  radius: number
  startangle: number
  endangle: number
  color: string
  type: string
  id: number
  bridge: string
  typename: string
  geom: string
}

export interface Bridgedeck {
  smuserid: number
  entityhand: number
  entitytype: string
  layer: string
  layerfroze: number
  layerlocke: number
  layeron: number
  elevation: number
  thickness: number
  colorindex: number
  linestyle: string
  blockname: string
  blockrotat: number
  linewidth: number
  x: number
  y: number
  z: number
  radius: number
  startangle: number
  endangle: number
  color: string
  type: string
  id: number
  typename: string
  bridge: string
  geom: string
}

export interface Bridgedata {
  id: number
  bridge: string
  completionTime: number
  designHighestNavigableWaterLevel: string
  designHighestNavigableWaterLevelReturnPeriod: number
  structuralType: string
  numberOfNavigableSpans: number
  actualClearWidthRightSpan: string
  actualClearHeightLeftSpan: number
  actualClearHeightRightSpan: string
  navigableSpanLengthLeftSpan: string
  navigableSpanLengthRightSpan: string
  highestNavigableWaterLevel: string
  leftChannelEdgeClearanceHeightLeftSpan: string
  leftChannelEdgeClearanceHeightRightSpan: string
  rightChannelEdgeClearanceHeightleftSpan: string
  rightChannelEdgeClearanceHeightrightSpan: string
  distanceFromChannelEdgeToChannelCenterlineleftSpan: string
  distanceFromChannelEdgeToChannelCenterlinerightSpan: string
  deckHeightAboveChannelCenterlineleftSpan: string
  deckHeightAboveChannelCenterlinerightSpan: string
  deckHeightAtLeftChannelEdgeLeftSpan: string
  deckHeightAtLeftChannelEdgeRightSpan: string
  deckHeightAtRightChannelEdgeLeftSpan: string
  deckHeightAtRightChannelEdgerightSpan: string
  distanceFromLeftChannelEdgeToNavigableSpanEdgeLeftSpa: string
  distanceFromLeftChannelEdgeToNavigableSpanEdgeRightSp: string
  distanceFromRightChannelEdgeToNavigableSpanEdgeLeftSp: string
  distanceFromRightChannelEdgeToNavigableSpanEdgeRightS: string
  leftSideDeckHeightOfNavigableSpanLeftSpan: string
  leftSideDeckHeightOfNavigableSpanrightSpan: string
  rightSideDeckHeightOfNavigableSpanLeftSpan: string
  rightSideDeckHeightOfNavigableSpanRightSpan: string
  leftSpanLeftPierLongitude: number
  leftSpanLeftPierLatitude: number
  navigableSpanPierLongitude: string
  navigableSpanPierLatitude: string
  rightSpanRightPierLongitude: string
  rightSpanRightPierLatitude: string
  geom: string
  pier: Bridgepier[]
  deck: Bridgedeck[]
}

export interface Sandbar {
  id: number
  geom: string
  name: string
  lon: number
  lat: number
  /** @format date-time */
  ct: string
  /** @format date-time */
  ut: string
}

export interface GasStation {
  id: number
  geom: string
  name: string
  lon: number
  lat: number
  /** @format date-time */
  ct: string
  /** @format date-time */
  ut: string
}

export interface Dock {
  id: number
  geom: string
  name: string
  longitude: number
  latitude: number
  /** @format date-time */
  ct: string
  /** @format date-time */
  ut: string
}

export interface AidStation {
  id: number
  geom: string
  name: string
  longitude: number
  latitude: number
  /** @format date-time */
  ct: string
  /** @format date-time */
  ut: string
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Maritime Server
 * @version 0.1
 * @contact
 *
 * 海图服务
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags App
   * @name AppControllerGetHello
   * @request GET:/
   */
  appControllerGetHello = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: 'GET',
      ...params,
    })

  camera = {
    /**
     * No description
     *
     * @tags camera
     * @name CameraControllerGetCameraList
     * @summary 摄像头列表
     * @request GET:/camera/list
     */
    cameraControllerGetCameraList: (params: RequestParams = {}) =>
      this.request<Camera[], any>({
        path: `/camera/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  ships = {
    /**
     * No description
     *
     * @tags ships
     * @name ShipsControllerGetStation
     * @summary 请求station
     * @request POST:/ships/getStation
     */
    shipsControllerGetStation: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/ships/getStation`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ships
     * @name ShipsControllerGetExtent2
     * @summary 范围请求
     * @request POST:/ships/getExtent2
     */
    shipsControllerGetExtent2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/ships/getExtent2`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ships
     * @name ShipsControllerGetShips
     * @summary 获取船只列表
     * @request GET:/ships/getShips
     */
    shipsControllerGetShips: (params: RequestParams = {}) =>
      this.request<Ship[], any>({
        path: `/ships/getShips`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ships
     * @name ShipsControllerGetShipinfo
     * @summary 获取船只详情
     * @request POST:/ships/getShipinfo
     */
    shipsControllerGetShipinfo: (data: ShipinfoDto, params: RequestParams = {}) =>
      this.request<ShipinfoVo[], any>({
        path: `/ships/getShipinfo`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  buoys = {
    /**
     * No description
     *
     * @tags buoys
     * @name BuoysControllerGetList
     * @request GET:/buoys/list
     */
    buoysControllerGetList: (params: RequestParams = {}) =>
      this.request<Navigationmark[], any>({
        path: `/buoys/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  dwrt = {
    /**
     * No description
     *
     * @tags dwrt
     * @name DwrtControllerGetClList
     * @request GET:/dwrt/clList
     */
    dwrtControllerGetClList: (params: RequestParams = {}) =>
      this.request<Dwrtcl1[], any>({
        path: `/dwrt/clList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dwrt
     * @name DwrtControllerGetPcList
     * @request GET:/dwrt/pcList
     */
    dwrtControllerGetPcList: (params: RequestParams = {}) =>
      this.request<Dwrtpc[], any>({
        path: `/dwrt/pcList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dwrt
     * @name DwrtControllerGetPtList
     * @request GET:/dwrt/ptList
     */
    dwrtControllerGetPtList: (params: RequestParams = {}) =>
      this.request<Dwrtpt1[], any>({
        path: `/dwrt/ptList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dwrt
     * @name DwrtControllerGetPtTile
     * @request GET:/dwrt/ptTile
     */
    dwrtControllerGetPtTile: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/dwrt/ptTile`,
        method: 'GET',
        ...params,
      }),
  }
  bridge = {
    /**
     * No description
     *
     * @tags bridge
     * @name BridgeControllerList
     * @request GET:/bridge/list
     */
    bridgeControllerList: (params: RequestParams = {}) =>
      this.request<Bridgedata[], any>({
        path: `/bridge/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  simpleLayers = {
    /**
     * No description
     *
     * @tags SimpleLayers
     * @name SimpleLayersControllerGetSandbars
     * @request GET:/simple-layers/getSandbars
     */
    simpleLayersControllerGetSandbars: (params: RequestParams = {}) =>
      this.request<Sandbar[], any>({
        path: `/simple-layers/getSandbars`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SimpleLayers
     * @name SimpleLayersControllerGetGasStations
     * @request GET:/simple-layers/getGasStations
     */
    simpleLayersControllerGetGasStations: (params: RequestParams = {}) =>
      this.request<GasStation[], any>({
        path: `/simple-layers/getGasStations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SimpleLayers
     * @name SimpleLayersControllerGetDocks
     * @request GET:/simple-layers/getDocks
     */
    simpleLayersControllerGetDocks: (params: RequestParams = {}) =>
      this.request<Dock[], any>({
        path: `/simple-layers/getDocks`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SimpleLayers
     * @name SimpleLayersControllerGetAidStations
     * @request GET:/simple-layers/getAidStations
     */
    simpleLayersControllerGetAidStations: (params: RequestParams = {}) =>
      this.request<AidStation[], any>({
        path: `/simple-layers/getAidStations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
